/*@flow*/
import gql from "graphql-tag";
import type { DocumentNode } from "graphql";

export const GetResourceList = (gql(`
  query GetResourceList($resourceName: String, $id: [ID]) {
    me {
      id
      company {
        id
        resources(id: $id, resourceName: $resourceName) {
          ... on Unit {
            __typename
            id
            name
          }
          ... on Contact {
            __typename
            id
            hashid
            name
          }
        }
      }
    }
  }
`): DocumentNode);
